import { render, staticRenderFns } from "./WorkspaceSurvey.vue?vue&type=template&id=af48c84e&"
import script from "./WorkspaceSurvey.vue?vue&type=script&lang=js&"
export * from "./WorkspaceSurvey.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceSurvey.vue?vue&type=style&index=0&id=af48c84e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports